/**
 * Taabiir Entrance Animations & Scroll Interactions
 * Uses Intersection Observer — no libraries, ~2KB
 */
(function () {
  'use strict';

  // ── Respect reduced motion ──────────────────────────────
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // ── CSS classes injected so we don't depend on stylesheet load order ──
  var style = document.createElement('style');
  style.textContent = [
    /* Base reveal state — hidden */
    '[data-reveal]{opacity:0}',
    '[data-reveal="up"]{transform:translateY(2.5rem)}',
    '[data-reveal="down"]{transform:translateY(-2.5rem)}',
    '[data-reveal="left"]{transform:translateX(3rem)}',
    '[data-reveal="right"]{transform:translateX(-3rem)}',
    '[data-reveal="scale"]{transform:scale(.94)}',
    /* Visible state */
    '[data-reveal].is-visible{opacity:1;transform:none}',
    '[data-reveal].is-visible{transition:opacity .8s cubic-bezier(.22,1,.36,1),transform .8s cubic-bezier(.22,1,.36,1)}',
    /* Stagger delays */
    '[data-reveal][data-delay="1"]{transition-delay:.08s}',
    '[data-reveal][data-delay="2"]{transition-delay:.16s}',
    '[data-reveal][data-delay="3"]{transition-delay:.24s}',
    '[data-reveal][data-delay="4"]{transition-delay:.32s}',
    '[data-reveal][data-delay="5"]{transition-delay:.4s}',
    '[data-reveal][data-delay="6"]{transition-delay:.48s}',
    '[data-reveal][data-delay="7"]{transition-delay:.56s}',
    '[data-reveal][data-delay="8"]{transition-delay:.64s}',
    /* Hero — play on load, not on scroll */
    '[data-reveal-hero]{opacity:0;transform:translateY(2rem)}',
    '[data-reveal-hero].is-visible{opacity:1;transform:none;transition:opacity 1s cubic-bezier(.22,1,.36,1) .3s,transform 1s cubic-bezier(.22,1,.36,1) .3s}',
    '[data-reveal-hero][data-delay="1"].is-visible{transition-delay:.5s}',
    '[data-reveal-hero][data-delay="2"].is-visible{transition-delay:.7s}',
    '[data-reveal-hero][data-delay="3"].is-visible{transition-delay:.9s}',
    '[data-reveal-hero][data-delay="4"].is-visible{transition-delay:1.1s}'
  ].join('\n');
  document.head.appendChild(style);

  // ── Auto-tag elements with reveal attributes ────────────
  function tagElements() {
    // Hero — animate on load
    var hero = document.querySelector('.tb-hero');
    if (hero) {
      var heroEls = hero.querySelectorAll('.tb-hero__tagline, .tb-hero__title, .tb-hero__desc, .tb-hero__cta, .tb-hero__actions');
      heroEls.forEach(function (el, i) {
        el.setAttribute('data-reveal-hero', '');
        el.setAttribute('data-delay', String(i));
      });
    }

    // Section headings & intros
    document.querySelectorAll(
      '.tb-split__intro, .tb-center-text__heading, .tb-creative__text, .tb-story__text, ' +
      '.tb-testimonials__header, .tb-countdown__inner, .tabiir-locations__inner, ' +
      '.tb-carousel__header, .collection__title, .title-wrapper-with-link'
    ).forEach(function (el) {
      el.setAttribute('data-reveal', 'up');
    });

    // Split gallery images — slide from sides
    document.querySelectorAll('.tb-split__col').forEach(function (el, i) {
      el.setAttribute('data-reveal', i % 2 === 0 ? 'left' : 'right');
      el.setAttribute('data-delay', String(i % 4));
    });

    // Center text images
    document.querySelectorAll('.tb-center-text__img').forEach(function (el, i) {
      el.setAttribute('data-reveal', 'scale');
      el.setAttribute('data-delay', String(i % 4));
    });

    // Creative showcase
    var creativeText = document.querySelector('.tb-creative__text');
    var creativeImg = document.querySelector('.tb-creative__img-primary');
    if (creativeText) creativeText.setAttribute('data-reveal', 'left');
    if (creativeImg) {
      creativeImg.setAttribute('data-reveal', 'right');
      creativeImg.setAttribute('data-delay', '1');
    }

    // Brand story
    var storyText = document.querySelector('.tb-story__text, .brand-story__text');
    var storyImg = document.querySelector('.tb-story__img, .brand-story__img');
    if (storyText) storyText.setAttribute('data-reveal', 'left');
    if (storyImg) {
      storyImg.setAttribute('data-reveal', 'right');
      storyImg.setAttribute('data-delay', '1');
    }

    // Carousel slides — stagger
    document.querySelectorAll('.tb-carousel__slide').forEach(function (el, i) {
      el.setAttribute('data-reveal', 'up');
      el.setAttribute('data-delay', String(Math.min(i, 4)));
    });

    // Jaipur collection products — stagger
    document.querySelectorAll('.tb-jaipur__product').forEach(function (el, i) {
      el.setAttribute('data-reveal', 'up');
      el.setAttribute('data-delay', String(Math.min(i, 4)));
    });

    // Jaipur header & feature
    var jaipurHeader = document.querySelector('.tb-jaipur__header');
    if (jaipurHeader) {
      jaipurHeader.setAttribute('data-reveal', 'up');
      jaipurHeader.setAttribute('data-delay', '0');
    }
    var jaipurFeature = document.querySelector('.tb-jaipur__feature');
    if (jaipurFeature) {
      jaipurFeature.setAttribute('data-reveal', 'left');
      jaipurFeature.setAttribute('data-delay', '1');
    }
    var jaipurGrid = document.querySelector('.tb-jaipur__grid');
    if (jaipurGrid) {
      jaipurGrid.setAttribute('data-reveal', 'right');
      jaipurGrid.setAttribute('data-delay', '2');
    }

    // Testimonial cards — stagger
    document.querySelectorAll('.tb-testimonial').forEach(function (el, i) {
      el.setAttribute('data-reveal', 'up');
      el.setAttribute('data-delay', String(i));
    });

    // Countdown units — stagger
    document.querySelectorAll('.tb-countdown__unit').forEach(function (el, i) {
      el.setAttribute('data-reveal', 'scale');
      el.setAttribute('data-delay', String(i));
    });

    // Location items — stagger
    document.querySelectorAll('.tabiir-locations__item').forEach(function (el, i) {
      el.setAttribute('data-reveal', 'up');
      el.setAttribute('data-delay', String(Math.min(i, 6)));
    });

    // NOTE: collection cards (.product-grid .grid__item), the product page
    // gallery/info (.product__media-wrapper / .product__info-wrapper) and
    // footer blocks are intentionally NOT tagged here. Stock Dawn already
    // reveals them via scroll-trigger (animations_reveal_on_scroll is on),
    // so tagging them too ran two reveal systems on the same elements — and
    // hid the product gallery (the LCP element) behind opacity:0 until JS ran.

    // Section headings h2 — scoped to page content so headings inside the
    // header, mega-menu or announcement bar are never tagged.
    document.querySelectorAll('main#MainContent section h2:not([data-reveal]):not([data-reveal-hero])').forEach(function (el) {
      if (!el.closest('.tb-hero')) {
        el.setAttribute('data-reveal', 'up');
      }
    });
  }

  // ── Reveal a single element ─────────────────────────────
  function reveal(el) {
    el.classList.add('is-visible');
    if (observer) observer.unobserve(el);
  }

  // ── Failsafe: reveal anything already within (or above) the
  //    viewport that the observer may have missed. Guarantees
  //    content is never left permanently hidden.
  function revealInView() {
    var vh = window.innerHeight;
    document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      // top has entered the lower 90% of the viewport, or element
      // already straddles/passed it (taller-than-viewport sections)
      if (r.top < vh * 0.9 && r.bottom > 0) reveal(el);
    });
  }

  // ── Intersection Observer for scroll reveals ────────────
  var observer = null;
  function initObserver() {
    // No IntersectionObserver support → show everything up front.
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, {
      // threshold 0 (any sliver) so sections taller than the viewport
      // still reveal; rootMargin triggers slightly before centre.
      threshold: 0,
      rootMargin: '0px 0px -10% 0px'
    });

    document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });

    revealInView();
  }

  // ── Hero animations — fire on load ──────────────────────
  function animateHero() {
    document.querySelectorAll('[data-reveal-hero]').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // ── Parallax for decorative motifs ──────────────────────
  function initParallax() {
    var motifs = document.querySelectorAll('.tb-split__motif');
    if (!motifs.length) return;

    var ticking = false;
    function update() {
      motifs.forEach(function (motif) {
        var rect = motif.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var speed = parseFloat(motif.dataset.parallaxSpeed || '0.15');
        var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * speed;
        motif.style.transform = 'translateY(' + (-offset).toFixed(1) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  // ── Re-tag dynamically loaded content (Load More) ───────
  function reTagAndObserve() {
    tagElements();
    initObserver();
  }

  // Expose for Load More callback
  window.tbReveal = reTagAndObserve;

  // ── Init ────────────────────────────────────────────────
  function init() {
    tagElements();
    initObserver();
    animateHero();
    initParallax();

    // Backstop: the observer handles the common case, but also
    // sweep on load and on scroll so nothing can stay hidden if a
    // reveal is missed (fast scroll, jump links, layout shifts).
    window.addEventListener('load', revealInView);
    var revealTicking = false;
    function backstopScroll() {
      // Nothing left to reveal → stop listening entirely instead of
      // running querySelectorAll + getBoundingClientRect on every scroll.
      if (!document.querySelector('[data-reveal]:not(.is-visible)')) {
        window.removeEventListener('scroll', backstopScroll);
        return;
      }
      if (revealTicking) return;
      revealTicking = true;
      requestAnimationFrame(function () {
        revealInView();
        revealTicking = false;
      });
    }
    window.addEventListener('scroll', backstopScroll, { passive: true });

    // Re-tag after Load More or dynamic content
    var loadMoreBtn = document.getElementById('load-more-btn');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        setTimeout(reTagAndObserve, 800);
      });
    }

    // Re-tag after AJAX page changes (collection filters)
    document.addEventListener('shopify:section:load', reTagAndObserve);
    document.addEventListener('collection:updated', reTagAndObserve);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
